<div class="container-fluid container--available-viewport-min-height">
  <div class="row">
    <div class="col-sm col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
      <form #formNewUser id="newUserForm" ngNativeValidate autocomplete="off" (submit)="submit()">
        <div class="form-group">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ "addNursesLabelHospitalName" | localize }}</span>
            </div>
            <input
              name="hospitalName"
              data-testid="add-nurses-hospital-name"
              [typeaheadScrollable]="true"
              [typeaheadOptionsInScrollableView]="7"
              [typeaheadMinLength]="0"
              [typeahead]="hospitalSuggestions$"
              [typeaheadAsync]="true"
              class="form-control"
              [(ngModel)]="selectedHospital"
              required
            />
            <div *ngIf="!hospitalNameValid" class="form-field-invalid-feedback">
              {{ "invalidHospitalNameLength" | localize }}
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ "addNursesLabelEmailAddresses" | localize }}</span>
            </div>
            <textarea
              id="userEmailsElement"
              data-testid="add-nurses-emails"
              class="form-control"
              name="userEmailsRaw"
              placeholder="{{ 'addNursesPlaceholderEmailAddresses' | localize }}"
              aria-describedby="emailHelp"
              [(ngModel)]="userEmailsRaw"
              required
              [rows]="10"
            ></textarea>
            <div *ngIf="invalidEmail" class="form-field-invalid-feedback">
              {{ "addNursesInvalidLabelEmailAddresses" | localize }}: "{{ invalidEmail }}".
            </div>
            <div *ngIf="invalidEmailLength" class="form-field-invalid-feedback">
              {{ "addNursesInvalidLabelEmailAddressesLength" | localize }}: "{{ invalidEmailLength }}".
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="feature447Released()">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ "addNursesLabelLanguage" | localize }}</span>
            </div>
            <app-select
              [inForm]="true"
              [value]="selectedLanguage"
              [options]="languageSelectionOptions"
              [testId]="'add-nurses-language-select'"
              (valueChanged)="selectedLanguage = $event"
            ></app-select>
          </div>
        </div>
        <action-button
          testId="add-nurses-submit"
          buttonClass="btn btn-outline-primary"
          buttonLabel="addNursesAddButtonLabel"
          actionInProgressLabel="addNursesAddButtonLoadingLabel"
          [actionInProgress]="addNursesInProgress$ | async"
        ></action-button>
      </form>
    </div>
  </div>
</div>

<ng-template #confirmSubmitTemplate>
  <div class="modal-body text-center">
    <p>
      {{ "addNursesQuestionConfirmSubmit" | localize }} <strong class="text-nowrap">"{{ selectedHospital }}"</strong>?
    </p>
    <ul class="text-start">
      <li *ngFor="let userEmail of userEmails">
        {{ userEmail }}
      </li>
    </ul>
    <button type="button" data-testid="add-nurses-confirm" class="btn btn-default" (click)="confirm()">{{ "modalResponseYes" | localize }}</button>
    <button type="button" class="btn btn-primary" (click)="decline()">{{ "modalResponseNo" | localize }}</button>
  </div>
</ng-template>
